module.exports = __webpack_public_path__ + "static/media/color_rendering_for_hotel_lobby_map_mural_2016.7d082aac.webp";